// extracted by mini-css-extract-plugin
export var card = "InlineBreaker-module--card--2_g4z";
export var fullHeight = "InlineBreaker-module--fullHeight--3bUpT";